/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { defineComponent } from '../../hooks/useDefinition';
import type {
  DialogOwnProps,
  DialogHeaderOwnProps,
  DialogBodyOwnProps,
  DialogFooterOwnProps,
} from './types';
import styles from './Dialog.module.css';

/**
 * Component definition for Dialog
 * @public
 */
export const DialogDefinition = defineComponent<DialogOwnProps>()({
  styles,
  classNames: {
    root: 'bui-DialogOverlay',
    container: 'bui-Dialog',
    inner: 'bui-DialogInner',
    content: 'bui-DialogContent',
  },
  propDefs: {
    children: {},
    className: {},
    width: {},
    height: {},
    style: {},
  },
});

/**
 * Component definition for DialogHeader
 * @public
 */
export const DialogHeaderDefinition = defineComponent<DialogHeaderOwnProps>()({
  styles,
  classNames: {
    root: 'bui-DialogHeader',
    title: 'bui-DialogHeaderTitle',
  },
  propDefs: {
    children: {},
    className: {},
  },
});

/**
 * Component definition for DialogBody
 * @public
 */
export const DialogBodyDefinition = defineComponent<DialogBodyOwnProps>()({
  styles,
  classNames: {
    root: 'bui-DialogBody',
  },
  propDefs: {
    children: {},
    className: {},
  },
});

/**
 * Component definition for DialogFooter
 * @public
 */
export const DialogFooterDefinition = defineComponent<DialogFooterOwnProps>()({
  styles,
  classNames: {
    root: 'bui-DialogFooter',
  },
  propDefs: {
    children: {},
    className: {},
  },
});
